<!--
 * @Author: wufei
 * @Date: 2020-08-07 13:34:45
 * @LastEditTime: 2020-09-04 17:55:55
 * @Description:
 * @FilePath: \mobile-revive\src\views\index\index.vue
-->
<template>
  <div class="index">
    <big-data v-if="active === 0" />
    <detail v-if="active === 1" />
    <month v-if="active === 2" />

    <tabbar v-model="active">
      <tabbar-item v-show="menuA" icon="chart-trending-o">复盘大数据</tabbar-item>
      <tabbar-item v-show="menuB" icon="notes-o">复盘明细</tabbar-item>
      <tabbar-item v-show="menuC" icon="bell">上月开盘</tabbar-item>
    </tabbar>
  </div>
</template>

<script>
import bigData from './bigData' // 复盘大数据
import detail from './detail' // 复盘明细
import month from './month' // 本月开盘
import { Tabbar, TabbarItem, Notify } from 'vant'
export default {
    name: 'Index',
    components: {
        Tabbar,
        TabbarItem,
        bigData,
        detail,
        month
    },
    data() {
        return {
            active: 0,
            menuA: true,
            menuB: true,
            menuC: true
        }
    },
    created() {
        const menuList = JSON.parse(sessionStorage.getItem('userDetail')).currentMenuList || []
        const a = menuList.find(item => item.permissionCode === 'm:reviveChart:A')
        const b = menuList.find(item => item.permissionCode === 'm:reviveChart:B')
        const c = menuList.find(item => item.permissionCode === 'm:reviveChart:C')
        this.menuA = !!a
        this.menuB = !!b
        this.menuC = !!c
        this.active = this.menuA ? 0 : '' || this.menuB ? 1 : '' || this.menuC ? 2 : ''
        if (this.active === '') {
            Notify({ type: 'danger', message: '暂无权限!' })
        }
    },
    beforeRouteLeave(to, from, next) {
        const status = to.name === 'report'
        console.log('leave', to)
        this.$store.commit('updateAliveList', { name: 'Index', status: status })
        setTimeout(() => {
            next()
        }, 20)
    }
}
</script>

<style lang="scss" scoped>
  .index {
    width:100%;
    height:100%;
  }
</style>

<style lang="scss">
  .index {
    .van-tabbar-item {
      font-size:.2rem /* 20/100 */;
    }

    .van-tabbar-item__icon {
      font-size:.4rem /* 40/100 */;
    }

    .van-tabbar {
      height:1rem /* 100/100 */;
    }
  }
</style>
